<template>
    <div id="fabric-js-container" ref="fabricJSContainer">
        <canvas id="fabric-js-canvas" class="workspace-module-container" ref="fabricJS"></canvas>
    </div>
</template>

<script>
    import {urlForFileStorage} from "../common";
    import {fabricEditor} from "../../fabric/fabricMain";
    import ModalConfirmation from "../Modal/ModalConfirmation";

    export default {
        name: "WorkspaceFabric.vue",
        mixins: [urlForFileStorage],
        data(){
            return {
            }
        },
        async mounted() {
            if (!this.$store.getters[`projectList/${this.$route.params.projectUUID}/photoList/${this.$route.params.photoID}/planeList/PLANE_EXIST_BY_ID`](this.$route.params.planeID)){
                this.$router.replace({
                    name: "planeCategories"
                }).catch(() => {})
                return
            }
            this.editor = new fabricEditor(this.$refs["fabricJS"]);
            this.editor.updateCanvaSize({
                width: this.$refs["fabricJSContainer"].offsetWidth,
                height: this.$refs["fabricJSContainer"].offsetHeight
                }
            )
            let source = await this.editor.addSourceImage(this.activePhotoAbsoluteURL);
            this.editor.showPlanesForTools(this.$store.state.route.params.planeID);
            this.editor.add_plane_drawing();
            this.editor.setViewport(source, 1);
        },
        destroyed() {
            if (this.editor)
                this.editor.destroy();
        },
        computed: {
            activePhotoAbsoluteURL() {
                return this.urlForFileStorage(this.$store.getters[`active/GET_ACTIVE_PHOTO`].src);
            }
        },
        methods: {

        },
        beforeRouteLeave (to, from, next) {
            if (!this.editor)
                next();

            if (this.editor.planeDrawingTool.unsaveChanges){
                const title = 'Внимание!';
                const text = 'Есть несохраненные изменения. Вы действительно хотите покинуть данную страницу?';

                this.$modal.show(ModalConfirmation, {title, text, alright: () => {next()}}, {
                    name: 'confirmationModal',
                    height: 'auto',
                    pivotY: 0.2,
                    width: 460,
                    draggable: true,
                });
            } else {
                next();
            }
        }
    }
</script>

<style scoped>
    #fabric-js-container {
        width: 100%;
        height: 100%;
    }
</style>
